import SharedBrandActivity from "@/components/profileDrawer/shared/brand-activity";
import React from "react";
import { ProfileBodyProps } from "../../types";

const BrandActivity = React.memo((props: ProfileBodyProps) => {
  const user = props.user;
  return <SharedBrandActivity userId={user.id} brandId={props.brandId} />;
});

BrandActivity.displayName = "BrandActivity";

export default BrandActivity;
